import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Send } from "lucide-react";
import { http, registerDeletionHost, formatApiError } from "../lib/api";

export const DeletionDialogHost = () => {
  const [req, setReq] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { registerDeletionHost((r) => { setReason(""); setReq(r); }); return () => registerDeletionHost(null); }, []);
  if (!req) return null;
  const cancel = () => { req.cancel(); setReq(null); };
  const send = async () => {
    setBusy(true);
    try {
      await http.post("/deletion-requests", { path: req.path, reason });
      toast.success("Demande de suppression envoyée à l'administrateur principal");
      req.resolve(); setReq(null);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[80] bg-slate-900/50 backdrop-blur-sm grid place-items-center p-4">
      <div data-testid="deletion-request-dialog" className="bg-white rounded-md w-full max-w-md border border-slate-200 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-2"><Trash2 className="h-5 w-5 text-rose-600" /><h3 className="font-display text-lg font-bold">Demander la suppression</h3></div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-slate-600">Seul l&apos;administrateur principal peut supprimer cet élément. Indiquez le motif : il recevra votre demande et pourra la valider.</p>
          <textarea data-testid="deletion-reason" className="input h-24" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motif (obligatoire) : doublon, erreur de saisie…" />
        </div>
        <div className="px-5 py-4 border-t border-slate-100 flex justify-end gap-2">
          <button data-testid="deletion-cancel-btn" onClick={cancel} className="px-4 py-2 text-sm rounded-md border border-slate-300 hover:bg-slate-50">Annuler</button>
          <button data-testid="deletion-send-btn" disabled={busy || reason.trim().length < 5} onClick={send} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-md bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-50"><Send className="h-4 w-4" />Envoyer la demande</button>
        </div>
      </div>
    </div>
  );
};
